import { AccrualDocument } from "../dto/financialDocument/accrual-document-extraction.schema";
import { ExtractedCounterpartyParty } from "./counterpartyDetailChanges";

export function extractedCounterpartyParty({
    document,
    party,
}: {
    document: AccrualDocument | null | undefined;
    party: "issuer" | "recipient";
}): ExtractedCounterpartyParty {
    const identifiers = document?.[party];
    const names = identifiers?.names ?? [];
    return {
        partyName: document?.counterpartyName?.trim() || names[0] || null,
        names,
        emails: identifiers?.emails ?? [],
        phoneNumbers: identifiers?.phoneNumbers ?? [],
        addresses: identifiers?.addresses ?? [],
    };
}
